export const OnBoardingSteps = ({ steps }: { steps: number[] }) => {
	return (
		<ul className="md:order-2 order-1 pb-2  flex items-center justify-center md:gap-8 gap-4 md:relative">
			{steps.map((progress, i) => (
				<li key={i} className="relative z-10">
					<span className="md:w-20 w-24 h-[6px] block bg-t-step-inactive rounded-full"></span>
					<span
						style={{ width: `${progress}%` }}
						className="absolute left-0 top-0 h-[6px] bg-t-dark-blue rounded-full transition-all duration-300"
					></span>
				</li>
			))}
		</ul>
	)
}
